/**
 * TanStack Query hooks for `custom-fraud-rule-engine-per-campaign-per-partner`.
 * Thin wrappers over ./api. Ported from the legacy
 * `usePerPartnerSlice(period)` fraud-report query.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	customFraudRuleEnginePerCampaignPerPartnerQueryKeys,
	type CreateCustomFraudRuleEnginePerCampaignPerPartnerBody,
	type ListCustomFraudRuleEnginePerCampaignPerPartnerResponse,
	type CustomFraudRuleEnginePerCampaignPerPartnerRow,
} from "./api";

export function useCustomFraudRuleEnginePerCampaignPerPartnerList(
	period?: string,
): UseQueryResult<ListCustomFraudRuleEnginePerCampaignPerPartnerResponse, Error> {
	return useQuery({
		queryKey: customFraudRuleEnginePerCampaignPerPartnerQueryKeys.list(period),
		queryFn: () => list(period),
	});
}

export function useCustomFraudRuleEnginePerCampaignPerPartnerCreate(): UseMutationResult<
	CustomFraudRuleEnginePerCampaignPerPartnerRow,
	Error,
	CreateCustomFraudRuleEnginePerCampaignPerPartnerBody
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({
				queryKey: customFraudRuleEnginePerCampaignPerPartnerQueryKeys.all,
			});
		},
	});
}

export function useCustomFraudRuleEnginePerCampaignPerPartnerDelete(): UseMutationResult<
	{ removed: boolean },
	Error,
	string
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({
				queryKey: customFraudRuleEnginePerCampaignPerPartnerQueryKeys.all,
			});
		},
	});
}
